(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
/* eslint-disable function-paren-newline */ function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        if (initialState) this.board = initialState;
        else this.board = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        // eslint-disable-next-line no-console
        console.log(initialState);
        this.score = 0;
        this.isStarted = false;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(row) {
                    var originalRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(_this.board[row]);
                    var newRow = _this.board[row].filter(function(cell) {
                        return cell !== 0;
                    });
                    for(var cell = 0; cell < newRow.length - 1; cell++)if (newRow[cell] === newRow[cell + 1]) {
                        newRow[cell] = newRow[cell] + newRow[cell + 1];
                        _this.score += Number(newRow[cell]);
                        newRow[cell + 1] = 0;
                        cell++;
                    }
                    var compressedRow = newRow.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(compressedRow.length < 4)compressedRow.push(0);
                    if (originalRow.toString() !== compressedRow.toString()) moved = true;
                    _this.board[row] = compressedRow;
                };
                var moved = false;
                for(var row = 0; row < 4; row++)_loop(row);
                if (moved) this.randomPlace();
                this.renderBoard();
                this.updateCellColor();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(row) {
                    var originalRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(_this.board[row]);
                    var newRow = _this.board[row].filter(function(cell) {
                        return cell !== 0;
                    }).reverse();
                    for(var cell = 0; cell < newRow.length - 1; cell++)if (newRow[cell] === newRow[cell + 1]) {
                        newRow[cell] = newRow[cell] + newRow[cell + 1];
                        _this.score += Number(newRow[cell]);
                        newRow[cell + 1] = 0;
                        cell++;
                    }
                    newRow = newRow.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(newRow.length < 4)newRow.push(0);
                    newRow.reverse();
                    if (originalRow.toString() !== newRow.toString()) moved = true;
                    _this.board[row] = newRow;
                };
                var moved = false;
                for(var row = 0; row < 4; row++)_loop(row);
                if (moved) this.randomPlace();
                this.renderBoard();
                this.updateCellColor();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.board = this.transpose(this.board);
                this.moveLeft();
                this.board = this.transpose(this.board);
                this.renderBoard();
                this.updateCellColor();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.board = this.transpose(this.board);
                this.moveRight();
                this.board = this.transpose(this.board);
                this.renderBoard();
                this.updateCellColor();
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                var _this = this;
                // when you started play
                // if (!this.isStarted) {
                //   return 'idle';
                // }
                // check for win
                if (this.board.some(function(row) {
                    return row.some(function(cell) {
                        return cell === 2048;
                    });
                })) return "win";
                // check for lose
                var emptyCells = this.board.some(function(row) {
                    return row.some(function(cell) {
                        return cell === 0;
                    });
                });
                var canMerge = this.board.some(function(row, rowIndex) {
                    return row.some(function(cell, cellINdex) {
                        var right = cellINdex < 3 && _this.board[rowIndex][cellINdex + 1] === cell;
                        var down = rowIndex < 3 && _this.board[rowIndex + 1][cellINdex] === cell;
                        return right || down;
                    });
                });
                if (!emptyCells && !canMerge) return "lose";
                // for playing
                return "playing";
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.board = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
                this.status = "playing";
                this.randomPlace();
                this.randomPlace();
                this.renderBoard();
                this.updateCellColor();
                this.getScore();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.board = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.randomPlace();
                this.randomPlace();
                this.score = 0;
                this.status = "playing";
                this.renderBoard();
                this.updateCellColor();
            }
        },
        {
            // Add your own methods here
            key: "transpose",
            value: function transpose(matrix) {
                return matrix[0].map(function(_, index) {
                    return matrix.map(function(row) {
                        return row[index];
                    });
                });
            }
        },
        {
            key: "isBoardFull",
            value: function isBoardFull() {
                for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
                    if (this.board[row][col] === 0) return false;
                }
                return true;
            }
        },
        {
            key: "randomPlace",
            value: function randomPlace() {
                if (this.isBoardFull()) return;
                var emptyCells = [];
                for(var row = 0; row < 4; row++){
                    for(var column = 0; column < 4; column++)if (this.board[row][column] === 0) emptyCells.push([
                        row,
                        column
                    ]);
                }
                var randomIndex = Math.floor(Math.random() * emptyCells.length);
                var _emptyCells_randomIndex = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[randomIndex], 2), randomRow = _emptyCells_randomIndex[0], randomColumn = _emptyCells_randomIndex[1];
                this.board[randomRow][randomColumn] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "renderBoard",
            value: function renderBoard() {
                var _this = this;
                var boardElement = document.querySelector(".game-field");
                var rows = boardElement.querySelectorAll("tr");
                var rowsArray = Array.from(rows);
                var cells = rowsArray.flatMap(function(row) {
                    return Array.from(row.querySelectorAll("td"));
                });
                cells.forEach(function(cell, index) {
                    var value = _this.board[Math.floor(index / 4)][index % 4];
                    cell.textContent = value === 0 ? "" : value;
                });
            }
        },
        {
            key: "updateCellColor",
            value: function updateCellColor() {
                var boardElement = document.querySelector(".game-field");
                var rows = boardElement.querySelectorAll("tr");
                var rowsArray = Array.from(rows);
                var cells = rowsArray.flatMap(function(row) {
                    return Array.from(row.querySelectorAll("td"));
                });
                cells.forEach(function(cell) {
                    var value = cell.textContent.trim();
                    cell.classList.remove("field-cell--2", "field-cell--4", "field-cell--8", "field-cell--16", "field-cell--32", "field-cell--64", "field-cell--128", "field-cell--256", "field-cell--512", "field-cell--1024", "field-cell--2048");
                    if (value !== "" && !isNaN(value)) cell.classList.add("field-cell--".concat(value));
                });
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$buttonStart = document.querySelector(".start");
var $197cd56b15c33885$var$score = document.querySelector(".game-score");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
function $197cd56b15c33885$var$CheckStatus() {
    if ($197cd56b15c33885$var$game.getStatus() === "lose") {
        $197cd56b15c33885$var$messageLose.classList.remove("hidden");
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
    } else if ($197cd56b15c33885$var$game.getStatus() === "win") {
        $197cd56b15c33885$var$messageWin.classList.remove("hidden");
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
    }
}
$197cd56b15c33885$var$buttonStart.addEventListener("click", function() {
    $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$buttonStart.textContent = "Restart";
    $197cd56b15c33885$var$buttonStart.classList.add("restart");
    $197cd56b15c33885$var$messageStart.textContent = "Playing";
    $197cd56b15c33885$var$CheckStatus();
});
$197cd56b15c33885$var$buttonStart.addEventListener("click", function() {
    if ($197cd56b15c33885$var$buttonStart.textContent === "Restart") {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$score.textContent = "0";
        $197cd56b15c33885$var$messageStart.classList.remove("hidden");
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
    }
});
var $197cd56b15c33885$var$isKeyPressed = false;
document.addEventListener("keydown", function(event) {
    if ($197cd56b15c33885$var$isKeyPressed) return;
    $197cd56b15c33885$var$isKeyPressed = true;
    if (event.key === "ArrowLeft") {
        $197cd56b15c33885$var$game.moveLeft();
        $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
        $197cd56b15c33885$var$CheckStatus();
    }
    if (event.key === "ArrowRight") {
        $197cd56b15c33885$var$game.moveRight();
        $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
        $197cd56b15c33885$var$CheckStatus();
    }
    if (event.key === "ArrowUp") {
        $197cd56b15c33885$var$game.moveUp();
        $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
        $197cd56b15c33885$var$CheckStatus();
    }
    if (event.key === "ArrowDown") {
        $197cd56b15c33885$var$game.moveDown();
        $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
        $197cd56b15c33885$var$CheckStatus();
    }
});
document.addEventListener("keyup", function() {
    $197cd56b15c33885$var$isKeyPressed = false;
});

})();
//# sourceMappingURL=index.0547dab4.js.map
